import { useState } from "react";
import { CommonDialog } from "../../common/CommonDialog";
import { Form } from "../../common/Form";
import { useTranslation } from "react-i18next";

export function ParamDialog({visible,onOK,onCancel})
{
    const {t} = useTranslation();
    const [param,setParam] = useState({param:''});
    const params = [
        {label:t('Editor.Booklet'),value:'booklet'},
        {label:t('Editor.Test_Id'),value:'testId'},
        {label:t('Editor.Test_Name'),value:'testName'},
        {label:t('Editor.Test_Type'),value:'testType'},
        {label:t('Editor.Test_Date'),value:'testDate'},
        {label:t('Editor.Item_count'),value:'itemCount'},
        {label:t('Editor.Section_code'),value:'sectCode'},
        {label:t('Editor.Section_name'),value:'sectName'},
        {label:t('Editor.Section_item_count'),value:'sectItemCount'},
        {label:t('Editor.Page_no'),value:'page'},
        {label:t('Editor.Page_count'),value:'pageCount'},
        {label:t('Editor.Date'),value:'date'}
    ];

    const _onOK=()=>{
        onOK(param);
    }
    const _onCancel=()=>{
        onCancel();
    }
    const onChange=(formData)=>{
        setParam(formData);
    }
    return(
        <>
            <CommonDialog header={t('Editor.Insert_parameter')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{width:'400px',height:'100px'}}>
            <Form id="formatParam" formData={param} columns="1" onChange={onChange}
                fields={[
                    {id:"param",ftype:"dropdown",field:"param",label:t('Editor.Parameter'),options:params}
                ]}>
            </Form>	
            </div>
            </CommonDialog>
        </>
    );
}